import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/home/Home";
import Register from "@/pages/register/Register";
import Mine from "@/pages/mine/Mine";
// import Questionnaire from "@/pages/questionnaire/Questionnaire";
import Exchange from "@/pages/exchange/Exchange";
import ShopDetail from "@/pages/shopDetail/ShopDetail";
import UpdateInfo from "@/pages/updateInfo/UpdateInfo";
import OrderDetail from "@/pages/orderDetail/OrderDetail";
import HelpEarn from "@/pages/helpEarn/HelpEarn";
import MyAccount from "@/pages/my-account/MyAccount";
import SignIn from "@/pages/signIn/SignIn";
import MyInfo from "@/pages/myInfo/MyInfo";
import ChangePwd from "@/pages/changePwd/ChangePwd";
import AnswerHistory from "@/pages/answerHistory/AnswerHistory";
import OffenQuestion from "@/pages/offenQuestion/OffenQuestion";
import PrivacyClauses from "@/pages/privacyClauses/PrivacyClauses";

import ActiveRules from "@/pages/activeRules/ActiveRules";
import ReadRecommend from "@/pages/readRecommend/ReadRecommend";
import HasBeenInvited from "@/pages/hasBeenInvited/HasBeenInvited";
import IncomeDetails from "@/pages/incomeDetails/IncomeDetails";
import UpdateAvatar from "@/pages/updateAvatar/UpdateAvatar";

import yhxy from "@/pages/yhxy/yhxy.vue";

import QuestionnaireItem from "@/pages/questionnaireItem/QuestionnaireItem.vue";
import IntegralAward from "@/pages/integralAward/IntegralAward.vue";
import AboutQuestionnaire from "@/pages/aboutQuestionnaire/AboutQuestionnaire.vue";
import HelpFeedback from "@/pages/helpFeedback/HelpFeedback.vue";
import Logon from "@/pages/logon/Logon.vue";
import Forgot from "@/pages/forgot/Forgot.vue";
import login from "@/pages/login/Login.vue";

//新页面
import Questionnaire from "@/components/questionnaire.vue";
import Rewards from "@/components/rewards.vue";
import Amazon from "@/components/amazon.vue";
import Paypal from "@/components/paypal.vue";
import Walmart from "@/components/walmart.vue";
import Profile from "@/components/profile";
import Email from "@/components/email";
import Password from "@/components/password";
import RedemptionRecords from "@/components/redemptionRecords.vue";
import UploadAvatar from "@/components/uploadAvatar";
import CurrentLevel from "@/components/currentLevel";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      meta: {
        showFooter: false
      },
      /*component: Home*/
      component: Home
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        showFooter: false
      },
      component: Register
    },
    {
      path: "/mine",
      name: "Mine",
      meta: {
        showFooter: true,
        requireAuth: true
      },
      component: Mine
    },
    {
      path: "/questionnaire",
      name: "Questionnaire",
      meta: {
        showFooter: true,
        requireAuth: true
      },
      component: Questionnaire
    },
    {
      path: "/exchange",
      name: "Exchange",
      meta: {
        showFooter: true,
        requireAuth: true
      },
      component: Exchange
    },
    {
      path: "/helpEarn",
      name: "HelpEarn",
      meta: {
        showFooter: true,
        requireAuth: true
      },
      component: HelpEarn
    },
    {
      path: "/shopDetail",
      name: "ShopDetail",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: ShopDetail
    },
    {
      path: "/updateInfo",
      name: "UpdateInfo",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: UpdateInfo
    },
    {
      path: "/orderDetail",
      name: "OrderDetail",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: OrderDetail
    },
    {
      path: "/myAccount",
      name: "MyAccount",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: MyAccount
    },
    {
      path: "/signIn",
      name: "SignIn",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: SignIn
    },
    {
      path: "/myInfo",
      name: "MyInfo",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: MyInfo
    },
    {
      path: "/changePwd",
      name: "ChangePwd",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: ChangePwd
    },
    {
      path: "/answerHistory",
      name: "AnswerHistory",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: AnswerHistory
    },
    {
      path: "/offenQuestion",
      name: "OffenQuestion",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: OffenQuestion
    },
    {
      path: "/privacyClauses/:id",
      name: "PrivacyClauses",
      meta: {
        showFooter: false
      },
      component: PrivacyClauses
    },

    {
      path: "/activeRules/",
      name: "ActiveRules",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: ActiveRules
    },
    {
      path: "/readRecommend",
      name: "ReadRecommend",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: ReadRecommend
    },
    {
      path: "/hasBeenInvited",
      name: "HasBeenInvited",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: HasBeenInvited
    },
    {
      path: "/incomeDetails",
      name: "IncomeDetails",
      meta: {
        showFooter: false
      },
      component: IncomeDetails
    },
    {
      path: "/updateAvatar",
      name: "UpdateAvatar",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: UpdateAvatar
    },
    {
      path: "/yhxy",
      name: "Yhxy",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: yhxy
    },
    {
      path: "/questionnaireItem",
      name: "QuestionnaireItem",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: QuestionnaireItem
    },
    {
      path: "/integralAward",
      name: "IntegralAward",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: IntegralAward
    },
    {
      path: "/aboutQuestionnaire",
      name: "AboutQuestionnaire",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: AboutQuestionnaire
    },
    {
      path: "/helpFeedback",
      name: "HelpFeedback",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: HelpFeedback
    },
    {
      path: "/logon",
      name: "logon",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: Logon
    },
    {
      path: "/forgot",
      name: "forgot",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: Forgot
    },
    {
      path: "/login",
      name: "login",
      meta: {
        showFooter: false,
        requireAuth: false
      },
      component: login
    },
    {
      path: "/rewards",
      name: "Rewards",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: Rewards
    },
    {
      path: "/rewards/amazon",
      name: "Amazon",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: Amazon
    },
    {
      path: "/rewards/paypal",
      name: "Paypal",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: Paypal
    },
    {
      path: "/rewards/walmart",
      name: "Walmart",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: Walmart
    },
    {
      path: "/settingsProfile",
      name: "Profile",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: Profile
    },
    {
      path: "/settingsEmail",
      name: "email",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: Email
    },
    {
      path: "/settingsPassword",
      name: "Password",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: Password
    },
    {
      path: "/uploadAvatar",
      name: "Password",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: UploadAvatar
    },
    {
      path: "/redemptionRecords",
      name: "redemptionRecords",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: RedemptionRecords
    },
    {
      path: "/currentLevel",
      name: "currentLevel",
      meta: {
        showFooter: false,
        requireAuth: true
      },
      component: CurrentLevel
    }
    // {
    // path: '/detail/:id',
    // name: 'Detail',
    // /*component: Detail*/
    // component: () => import('@/pages/detail/Detail')
    // }
  ],

  //初始化滚动 始终回到顶部
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js